import React, { useState } from "react";
import { Plus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQS } from "../../data/site";
import { Reveal } from "./Reveal";

export const FAQ = () => {
  const [open, setOpen] = useState(-1);

  return (
    <section id="faq" className="relative py-24 md:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <div className="text-center">
          <Reveal>
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
              FAQ
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-heading mt-5 text-4xl font-semibold leading-[1.15] tracking-tight text-[#111E16] md:text-5xl">
              Questions, answered.
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 0.05}>
                <div
                  className="overflow-hidden rounded-2xl border border-[#E8EBE9] bg-white"
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    data-testid={`faq-trigger-${i}`}
                  >
                    <span className="font-heading text-lg font-medium text-[#111E16]">
                      {item.q}
                    </span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-[#2F5E43] transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 pb-6 leading-relaxed text-[#4A5F52]">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
